import { render, staticRenderFns } from "./NODATA.vue?vue&type=template&id=d530a408&"
import script from "./NODATA.vue?vue&type=script&lang=js&"
export * from "./NODATA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports